<div class="noticia-contenedor">
  <section-header [data]="dataHeader"> </section-header>
  <div class="contenido" [innerHtml]="content"></div>
</div>
